import Component from '../core/Component'
import { substitute } from '../utils/String'
import debounce from 'lodash/debounce'
import isEmpty from 'lodash/isEmpty'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

const STATES = {
    FILTERED: 'is-filtered',
}

export const EMITS = {
    CHANGE: 'change',
}

export default class Filter extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            resetButton: null,
            applied: null,
            templateAppliedGroup: null,
            templateAppliedGroupTag: null,
        }

        this.templateAppliedGroup = this.ref.templateAppliedGroup.innerText.trim()
        this.templateAppliedGroupTag = this.ref.templateAppliedGroupTag.innerText.trim()

        this.lastFilter = null
        this.debouncedCheck = debounce(this.check, 100)

        this.FILTERS = {
            location: {
                title: 'Město',
                inputName: 'location[]',
                values: this.getInputValues('location[]'),
            },
            sport: {
                title: 'Sport',
                inputName: 'sport[]',
                values: this.getInputValues('sport[]'),
            },
            role: {
                title: 'Pozice',
                inputName: 'role[]',
                values: this.getInputValues('role[]'),
            },
            type: {
                title: 'Forma úvazku',
                inputName: 'type[]',
                values: this.getInputValues('type[]'),
            },
        }
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)
        this.ref.resetButton.addEventListener('click', this.handleResetButtonClick)

        setTimeout(() => {
            this.check()
        }, 0);
    }

    handleResetButtonClick = (event) => {
        event.preventDefault()
        this.reset()
    }

    handleChange = () => {
        this.debouncedCheck()
    }

    reset() {
        const checkboxes = [...this.element.querySelectorAll('input[type="checkbox"]')]
        checkboxes.forEach((checkbox) => (checkbox.checked = false))

        this.check()
    }

    check() {
        const formData = new FormData(this.element)
        const filter = {}

        for (const filterKey in this.FILTERS) {
            const filterDef = this.FILTERS[filterKey]

            const values = formData.getAll(filterDef.inputName)
            if (values.length != 0) {
                if (filterDef.title == 'Sport') {
                    filter[filterKey] = {
                        rule: 'array_contains',
                        values: ['', ...values],
                    }
                } else {
                    filter[filterKey] = {
                        rule: 'array_contains',
                        values
                    }
                }
            }
            //mozno pohandlit jiny inputy nez checkboxlist
        }

        if (JSON.stringify(this.lastFilter) !== JSON.stringify(filter)) {
            this.emit(EMITS.CHANGE, { filter })
        }

        this.lastFilter = filter
        this.renderApplied()
    }

    highlightAvailableFilters(availableFilters) {
        for (const filterKey in this.FILTERS) {
            for (const valueKey in this.FILTERS[filterKey].values) {
                const filterValue = this.FILTERS[filterKey].values[valueKey]

                if (filterValue.element.dataset.groupHead) {
                    continue
                }

                filterValue.element.classList.add('is-unavailable')
                // triggerEvent(filterValue.element, 'change')
            }
        }

        for (const filterKey in availableFilters) {
            availableFilters[filterKey].values.forEach((valueKey) => {
                const filterValue = this.FILTERS[filterKey].values[valueKey]
                if (!filterValue) {
                    console.error(
                        `Available value '${valueKey}' for '${filterKey}' but input/option element doesn't exist with this value on this filter`
                    )
                    return
                }
                filterValue.element.classList.remove('is-unavailable')
                // triggerEvent(filterValue.element, 'change')
            })
        }
    }

    renderApplied() {
        const filter = this.lastFilter
        if (!filter || isEmpty(filter)) {
            this.element.classList.remove(STATES.FILTERED)
            return
        }

        const html = Object.entries(filter)
            .map(([filterKey, filterData]) => {
                return substitute(this.templateAppliedGroup, {
                    name: this.FILTERS[filterKey].title,
                    tags: filterData.values
                        .filter((filterValue) => filterValue !== '')
                        .map((filterValue) =>
                            substitute(this.templateAppliedGroupTag, {
                                title: this.FILTERS[filterKey].values[filterValue].label,
                            })
                        )
                        .join(''),
                })
            })
            .join('')
        this.ref.applied.innerHTML = html
        this.element.classList.add(STATES.FILTERED)

        EventBus.emit(EVENTS.DOM_CHANGE)
    }

    //vraci dictionary {value: inputElement, label}
    getInputValues(inputName) {
        let result = {}

        const inputs = [...this.element.querySelectorAll(`input[name="${inputName}"]`)]
        result = inputs.reduce((acc, element) => {
            acc[element.value] = {
                element,
                label: element.closest('label').innerText,
            }
            return acc
        }, {})

        //if (XXXX) - mozno pohandlit jiny inputy nez checkboxlist

        return result
    }
}
